export default "__VITE_ASSET__V_Jl4WK9__"